<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'activityList'}">
                        活动管理
                    </router-link>
                </li>
                <li class="active">活动商品管理</li>
            </ol>
        </div>
        <div class="content-operator content-border">
            <el-button type="primary"
                       @click="$common.goRouterLink({ name: 'goodsList', query: { activityId: $route.query.activityId }})"
                       size="small">添加活动商品
            </el-button>
        </div>
        <div class="content-query content-border">
            <el-form :inline="true" :model="query" class="demo-form-inline">
                <el-form-item label="　关键词：">
                    <el-input placeholder="请输入关键词" v-model="query.keyword"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitQuery(1)" size="small">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <hr/>
        <div class="title">
            <span>({{title}})<span class="subTitle">商品列表</span></span>
        </div>
        <div class="content-data" v-if="goodses && 0 < goodses.length">
            <el-table highlight-current-row :data="goodses" border ref="multipleTable"
                      @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection"/>
                <el-table-column align="center" label="图片">
                    <template slot-scope="scope">
                        <el-image style="height: 100px; width: 100px;" :src="dynamicPath+scope.row.iconPath">
                            <div slot="error" class="image-slot">
                                <el-image title="加载失败"
                                          src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/%E5%9B%BE%E7%89%87.png"/>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="名称" prop="name"/>
                <el-table-column align="center" label="售价" prop="price"/>
                <el-table-column align="center" label="成本价" prop="costPrice"/>
                <el-table-column align="center" label="销量" prop="saleAmount"/>
                <el-table-column align="center" label="库存" prop="stockAmount"/>
                <el-table-column align="center" fixed="right" label="操作" width="500px">
                    <template slot-scope="scope">
                        <el-button type="danger" @click="deleteGoods(scope.row.id)" size="mini" round>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="content-data" v-else>
            没有查询到数据
        </div>
        <vue-pager v-bind:datafile="fillData" url="activityRelation/pageActivityRelationGoods" v-bind:query="query" ref="pager"
                   v-bind:init="true"></vue-pager>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                query: {},
                dynamicPath: config.dynamicResourcePath,
                title: '',
                goodses:[]

            }
        },
        created() {
            var _this = this;
            _this.title = _this.$route.query.title;
            _this.query.activityId = _this.$route.query.activityId;
            _this.findGoodsTypeOne();
        },
        methods: {
            handleSelectionChange(val) {
                this.checkInputs = val;
            },
            deleteGoods(_goodsId) {
                var _this = this;
                _this.$common.my_ajax({
                    url: 'activityRelation/deleteActivityRelation',
                    data: {
                        activityRelationId: _goodsId
                    },
                    success: function (response) {
                        _this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1000,
                            onClose: function () {
                                _this.submitQuery(_this.query.current);
                            }
                        });
                    }
                });
            },
            fillData(response) {
                this.goodses = response.items || [];
            },
            submitQuery(_num) {
                var _this = this;
                _this.goodses = [];
                _this.$set(_this.query, 'goodsTypeId', _this.goodsTypeIdTwo || _this.goodsTypeIdOne);
                _this.$refs.pager.gotoPage(_num);
            },
            findGoodsTypeOne() {
                var _this = this;
                _this.$common.my_ajax({
                    url: 'goodsType/pageGoodsTypeByManager',
                    data: {
                        level: 1
                    },
                    success: function (response) {
                        _this.goodsTypeOnes = response.items;
                    }
                });
            },
        },
        watch: {
            '$route'(to, from) {
                var _this = this;
                if (to.name == from.name) {
                    _this.query = {};
                    _this.$set(_this.query, 'spaceType', _this.$route.query.spaceType);

                    _this.goodses = [];
                    _this.$nextTick(function () {
                        _this.$refs.pager.gotoPage();
                    });
                }
            }
        },
    }
</script>
<style scoped>
    .subTitle {
        color: darkgray;
        font-size: 14px;
        padding-left: 5px;
    }
</style>